import z from "zod";

// TODO: Add actual error types for Permissions backend logic
const permissionsErrorTypeValues = ["PLACEHOLDER_ERROR"] as const;

const permissionsErrorTypeSchema = z.enum(permissionsErrorTypeValues);
const PermissionsErrorType = permissionsErrorTypeSchema.enum;
type PermissionsErrorType = z.infer<typeof permissionsErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type PermissionsErrors = {
  errorType: typeof PermissionsErrorType.PLACEHOLDER_ERROR;
  // TODO: Add specific data fields for Permissions errors
  data: Record<string, never>;
};

export const permissionsErrorDetails: Record<PermissionsErrorType, ErrorDetails> = {
  [PermissionsErrorType.PLACEHOLDER_ERROR]: {
    sentryDescription: "Permissions backend logic error",
  },
};
